import { AuthFetchWithResponse } from 'src/Types/api'
import { ApiResult, throwApiError } from 'src/Libs/api'
import { StatusCodes } from '@e3dc-react/shell/Libs'
import { AuthFetchError } from '@e3dc-react/shell/Types'
import { ControlledDto } from 'src/Libs/flow/installation/api'

type ControlledEvseParametersPUTDto = Pick<
  ControlledDto['parameters'],
  | 'protection'
  | 'priority'
  | 'activated'
  | 'useMidMeter'
  | 'pulseWeight'
  | 'sunMode'
  | 'authenticationMode'
  | 'phasesManagement'
  | 'minCurrent'
  | 'chargeInFallbackModeAllowed'
  | 'fallbackMaxCurrent'
  | 'minCurrentSunMode'
  | 'ledIntensity'
  | 'phaseMapping'
  | 'lockCable'
>

type ControlledEvseSubTypeParametersPUTDto = Pick<
  ControlledDto['evseSubTypeParameters'],
  'ocppActivation' | 'ocppServerAddress' | 'ocppId' | 'ocppAuthType' | 'deviceReference' | 'wbType'
> &
  Partial<Pick<ControlledDto['evseSubTypeParameters'], 'keyLockMode'>>

export type ControlledEebusPUTDto = Pick<ControlledDto, 'deviceName'> & {
  parameters: ControlledEvseParametersPUTDto
}

export type ControlledModbusTcpPUTDto = Pick<ControlledDto, 'deviceName'> & {
  // Make 'lockCable' optional for modbus devices (WittyFlex)
  parameters: Omit<ControlledEvseParametersPUTDto, 'lockCable'> & { lockCable?: boolean }

  evseSubTypeParameters: ControlledEvseSubTypeParametersPUTDto
}

export const updateEvse = async (
  installationId: number,
  deviceId: string,
  evseId: string,
  evse: ControlledEebusPUTDto | ControlledModbusTcpPUTDto,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<null>> => {
  try {
    const response = await authFetch({
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      path: `installations/${installationId}/device-links/${deviceId}/sub/controlled/${evseId}`,
      method: 'PUT',
      payload: evse,
    })

    if (response.status !== StatusCodes.OK) {
      return new ApiResult<null, Error | AuthFetchError>(null, true)
    }

    return new ApiResult<null>(null)
  } catch (error) {
    return throwApiError(error, 'Failed to update EVSE:')
  }
}
